<template>
  <NuxtLayout name="v1">
    <template #main v-if="!notAvailable">
      <div class="py-5 left-container">
        <V3ProductComponent :data="product" @storeClose="handleStoreClose()" class="mb-8" />
      </div>
    </template>
    <template #footer v-if="!notAvailable">
      <div class="w-full md:justify-center left-container">
        <div class="relative">
          <div class="flex-col items-start" v-if="deliveryOffer && deliveryOffer.percent > 0">
            <div class=" flex">
              <div class="relative -mt-8 mr-4 z-20">
              <div v-if="deliveryOffer?.percent !== 100" class="relative w-[60px] h-[60px]">
                <div class="absolute inset-0 flex items-center justify-center z-0">
                  <V3ImageComponent
                    src="icons/mall4allabout.png"
                    class="w-5 h-5 object-contain"
                  />
                </div>
                <circle-progress
                  :percent="deliveryOffer?.percent"
                  :size="60"
                  :border-width="8"
                  :border-bg-width="8"
                  fill-color="#067161"
                  empty-color="#D1D8D8"
                  background="none"
                  :linecap="'round'"
                  :transition="300"
                  :is-shadow="false"
                  :show-percent="false"
                  class="z-10"
                />
              </div>

              <V3ImageComponent
                v-else
                src="icons/confetti.png"
                class="rounded-full w-14 h-14 object-cover"
                style="background-color: #067161; padding: 10px;"
              />
            </div>

            <div class="flex items-center">
              <h5
                class="font-semibold text-sm md:text-md dark:text-gray-900"
                v-if="deliveryOffer.percent !== 100"
              >
              Add items worth &#8377;{{deliveryOffer?.remainingAmount}} more to get Free Delivery
               
              </h5>
              <h5
                class="font-semibold text-sm md:text-md dark:text-gray-900"
                v-else
              >
                Hooray! FREE DELIVERY unlocked.
              </h5>
            </div>
        </div>
        <UDivider class="py-4" />
      </div>
    </div>
        <div class="w-full flex justify-end p-2 bg-gray-100" v-show="cartItem">
          <V3CartOverviewComponent />
        </div>
        <div class="w-full md:flex md:justify-center" v-show="!cartItem">
          <div class="" v-if="!isOutOfStock && !isStoreClosed">
            <V3CartButtonComponent :product="product" size="xl" label="Add To Cart" :disabled="isOutOfStock" :customize="isCustomizationAvailable" />
          </div>
          <div class="border border-red-200 bg-gray-100 rounded-full p-2 text-center" v-else-if="isOutOfStock">
            <p class="text-red-500">Out of Stock</p>
          </div>
          <div class="border border-red-200 bg-gray-100 rounded-full p-2 text-center" v-else-if="isStoreClosed">
            <p class="text-red-500">Store closed</p>
          </div>
        </div>
      </div>
      <V3PageLoaderComponent v-if="isFetchingLocation" :text="loadingMessage" class="dark:text-black fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/80 z-50" />
    </template>
  </NuxtLayout>
</template>

<script setup>
import { V3ModalComponent, V3PopupComponent } from '#components';
const { gtag } = useGtag();
const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };
const notAvailable = ref(true);
const route = useRoute();
const skuId = route.params.id;
const { isMobile } = useDevice();
const slideover = useSlideover();
const modal = useModal();
const location = useLocation();
const isLocationAvailable = computed(() => location.isGPSEnabled);
const isFetchingLocation = ref(false);
const loadingMessage = ref('');
const isStoreClosed = ref(false);
if(!location.city?.name && isAuthenticated && route.path !== '/') {
  navigateTo({ path: '/select-location', query: { from: 'home' } })
}

const result = await useAPIHandler('get', `/products/${skuId}`, {
    query: { partner_id: useRuntimeConfig().public.partnerCode },
  });
const product = result.data || {}; 
if (result.data && result.data.status == "enable") {
  notAvailable.value = false;
} else {
  notAvailable.value = true; 
}
const cart = useCart();
import CircleProgress from "vue3-circle-progress";
const OfferStatus = computed(() => useCheckOffer())
const deliveryOffer = computed(() => OfferStatus.value.delivery?.[0] || {})
const cartItem = computed(() => cart.items.find(item => item.sku_id === product?.sku_id));
const isCustomizationAvailable = computed(() => (product?.customizations && product?.customizations?.customizations && product?.customizations?.customizations?.length > 0) ? true : false);
const isOutOfStock = product?.stock ? Number(product?.stock?.available) === 0 : false;
const { getTrackingContext } = useTracking();
const trackingContext = getTrackingContext();
onMounted(() => {
  localStorage.removeItem('selectedOrder');
  if (notAvailable.value) {
    const modalType = ref('');
    if (isMobile) {
      modalType.value = "v3-popup"
      slideover.open(V3PopupComponent, { component: 'error', data: {message: "Item not found. Please try a different item."},
      onClose: () => {
        slideover.close
        navigateTo({ path: "/" })
      }});
    } else {
      modalType.value = "v3-modal"
      modal.open(V3ModalComponent, { component: 'error', data: {message: "Item not found. Please try a different item."},
      onClose: () => {
        modal.close
        navigateTo({ path: "/" })
      }});
    }

    const outsideModalClick = (event) => {
      const modalElement = document.querySelector(`[data-name="${modalType.value}"]`);
      if (modalElement && !modalElement.contains(event.target)) {
        modal.close();
        slideover.close();
        navigateTo({ path: '/' });
        document.removeEventListener('click', outsideModalClick);
      }
    };
    document.addEventListener('click', outsideModalClick);
  } else {
    if (!isLocationAvailable.value) {
      loadingMessage.value = 'Fetching current location please wait...';
      isFetchingLocation.value = true;
      const { getCurrentLocation, emitter } = useLocationFinder();
      getCurrentLocation();
      emitter.on('success', async (coords) => {
          await location.setCoords(coords.latitude, coords.longitude);
          isFetchingLocation.value = false;
          loadingMessage.value = "";
          window.location.reload(); // reload to re-trigger any logic dependent on location
        });
        emitter.on('error', () => {
          handleLocationError('Unable to fetch location. Please select manually.')
        })
      return;
    }
  }
});

const handleStoreClose = () => {
  isStoreClosed.value = true;
}

const handleLocationError = (
      message = 'Something went wrong while fetching location. Please select manually.'
    ) => {
      loadingMessage.value = message
      isFetchingLocation.value = false
      const routeUrl = useRoute();

      const popupOptions = {
        component: 'location',
        onSuccess: () => window.location.reload(),
        onClose: () => (isMobile ? slideover.close() : modal.close()),
      }

      if (!location.city?.name && !isAuthenticated) {
        isMobile
            ? slideover.open(V3PopupComponent, popupOptions)
            : modal.open(V3ModalComponent, popupOptions)
      }else if(!location.city?.name && isAuthenticated && routeUrl.path !== '/'){
        navigateTo({ path: '/select-location', query: { from: 'home' } })
      }
}

useSeoMeta({
  title: `${product?.name  ?? ''} - ${product?.provider?.name  ?? ''} - ${product?.provider?.id  ?? ''}`
});

const filterTags = product?.filter_tags || [];
const providerUkid = product?.provider?.ukid || "Not Available";
const categoryTag = filterTags.find(tag => tag.code === 'category');
const subCategoryTag = filterTags.find(tag => tag.code === 'sub_category');

const categoryName = categoryTag?.value?.[0] || "Not Available";
const subCategoryName = subCategoryTag?.value?.[0] || "Not Available";
const providerName = product?.provider?.name || "Not Available";

// Track the pdp_event with gtag
gtag('event', 'pdp_event', {
    product_name: product?.name,
    product_skuid: product?.sku_id,
    provider_name: providerName,
    provider_ukid: providerUkid,
    category_name: categoryName,
    sub_category_name: subCategoryName,
    source_page: trackingContext.source_page,
    current_page: trackingContext.current_page,
    ...userData,
});

definePageMeta({
  // keepalive: true,
});

</script>